import React, { useState, useRef } from "react";
import { useFormik } from "formik";
import { register, uploadMembersImages } from "../../../../../apis/api";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { useLocation, useNavigate } from "react-router-dom";
import "./MemberShipForm.css";

export const MemberShipForm = () => {
  const [img1, setImg1] = useState(null);
  const [img2, setImg2] = useState(null);
  const [img3, setImg3] = useState(null);
  const [activeStep, setActiveStep] = useState(1);
  const navigate = useNavigate();
  const toast = useRef(null);
  const location = useLocation();

  const handleMobileChange = (e, field) => {
    const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 10);
    formik.setFieldValue(field, digitsOnly);
  };

  const uploadImages = async (id) => {
    const fd = new FormData();
    if (img1 !== undefined && img1 !== null) {
      fd.append("representative1", img1);
    }
    if (img2 !== undefined && img2 !== null) {
      fd.append("representative2", img2);
    }
    if (img3 !== undefined && img3 !== null) {
      fd.append("representative3", img3);
    }
    uploadMembersImages(id, fd).then((res) => {
      if (Array.isArray(res)) {
        showUploadSuccess();
        setTimeout(() => {
          navigate("/userManagement/allMembers");
        }, 3000);
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "There is an Error while upload images. Please Try Again",
          life: 3000,
        });
      }
    });
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      name_of_org: "",
      address: "",
      phone_number: "",
      fax: "",
      mobile: "",
      website: "",
      year_of_estd: "",
      nature_of_business: "",
      member_category: "",
      membership_category: "",
      annual_turnover: "",
      authorized_capital: "",
      paid_up_capital: "",
      domestic_sales: "",
      exports_sales: "",
      total_sales: "",
      product_desc: "",
      GSTIN: "",
      PAN: "",
      MSME_registration_no: "",
      representative1_first_name: "",
      representative1_middle_name: "",
      representative1_last_name: "",
      representative2_first_name: "",
      representative2_middle_name: "",
      representative2_last_name: "",
      representative3_first_name: "",
      representative3_middle_name: "",
      representative3_last_name: "",
      designation_of_representative1: "",
      designation_of_representative2: "",
      designation_of_representative3: "",
      MEM_id_no: "",
      payment_type: "",
      payment_type_no: "",
      type_of_member: "",
      proposed_by: "",
      proposed_by_id_no: "",
      seconded_by: "",
      seconded_by_id_no: "",
      address2: "",
      address3: "",
      city: "",
      pincode: "",
      state: "",
      landline1: "",
      landline2: "",
      landline3: "",
      description: "",
      cin_no: "",
      date_of_admission: "",
      date_of_estd: "",
      mobile_of_repr1: "",
      mobile_of_repr2: "",
      mobile_of_repr3: "",
      email_of_representative1: "",
      email_of_representative2: "",
      email_of_representative3: "",
      membership_terminated: "",
      introducer_name: "",
      introducer_mobile_no: "",
      referred_by: "",
      remarks: "",
      is_active: "",
      amount_collected: "",
      exports: "",
    },
    validate: (data) => {
      let errors = {};
      if (!data.name_of_org) {
        errors.name_of_org = "This Field is Required.";
      }
      if (!data.address) {
        errors.address = "This Field is Required.";
      }
      if (!data.MEM_id_no) {
        errors.MEM_id_no = "This Field is Required.";
      }
      if (!data.membership_category) {
        errors.membership_category = "This Field is Required.";
      }
      if (!data.member_category) {
        errors.member_category = "This Field is Required.";
      }
      if (!data.representative1_first_name) {
        errors.representative1_first_name = "First name is required";
      }
      if (!data.representative1_last_name) {
        errors.representative1_last_name = "Last name is required";
      }
      if (!data.designation_of_representative1) {
        errors.designation_of_representative1 = "This Field is Required";
      }
      if (!data.state) {
        errors.state = "This Field is Required";
      }
      return errors;
    },
    onSubmit: (data) => {
      const registerData = {};
      Object.entries(data).forEach(([key, value]) => {
        if (value === null || value === undefined) return;
        if (typeof value === "string") {
          if (value.trim() === "") return;
          registerData[key] = value.trim();
          return;
        }
        registerData[key] = value;
      });

      const buildFullName = (first, middle, last) =>
        [first, middle, last].filter(Boolean).join(" ").trim();

      const rep1Full = buildFullName(
        data.representative1_first_name,
        data.representative1_middle_name,
        data.representative1_last_name
      );
      const rep2Full = buildFullName(
        data.representative2_first_name,
        data.representative2_middle_name,
        data.representative2_last_name
      );
      const rep3Full = buildFullName(
        data.representative3_first_name,
        data.representative3_middle_name,
        data.representative3_last_name
      );

      if (rep1Full) registerData.name_of_representative1 = rep1Full;
      if (rep2Full) registerData.name_of_representative2 = rep2Full;
      if (rep3Full) registerData.name_of_representative3 = rep3Full;

      const { email, ...newdata } = registerData;
      const rData = {
        ...newdata,
        email:
          formik.values.email !== ""
            ? formik.values.email
            : formik.values.MEM_id_no,
      };

      register(rData)
        .then((res) => res.data)
        .then((res) => {
          if (res.status === "success") {
            if (img1 !== null || img2 !== null || img3 !== null) {
              uploadImages(res?.data?.member_id);
            } else {
              showSuccess();
              setTimeout(() => {
                navigate("/userManagement/allMembers");
              }, 3000);
            }
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Something went wrong try agian later!",
              life: 3000,
            });
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            window.location.replace("/");
          } else {
            if (err?.response?.data?.err?.data) {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: err?.response?.data?.err?.data,
                life: 3000,
              });
            } else {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong try agian later!",
                life: 3000,
              });
            }
          }
        });
      formik.handleReset();
    },
  });

  const memberOptions = ["ordinary", "patron"];

  const showSuccess = () => {
    toast.current.show({
      severity: "success",
      summary: "Membership Form Submitted",
      detail:
        "The Membership form has been submitted and the respective authorities will review and approve",
      life: 5000,
    });
  };

  const showUploadSuccess = () => {
    toast.current.show({
      severity: "success",
      summary: "All Documents Submitted",
      detail: "All the respective Documents were Uploaded",
      life: 5000,
    });
  };

  const setNatureOfBussiness = (val) => {
    if (
      val === "Small Scale Manufacturing Activity" ||
      val === "Large Scale Manufacturing Activity"
    ) {
      formik.values.nature_of_business = "Manufacture";
    }
    if (
      val === "Small Scale Trading Activity" ||
      val === "Large Scale Trading Activity"
    ) {
      formik.values.nature_of_business = "Trade";
    }
    if (
      val === "Small Scale Service Activity" ||
      val === "Large Scale Service Activity"
    ) {
      formik.values.nature_of_business = "Service";
    }
    if (val === "District Chambers Of Commerce") {
      formik.values.nature_of_business = "District Chambers Of Commerce";
    }
    if (val === "Association") {
      formik.values.nature_of_business = "Association";
    }
    if (val === "Profession") {
      formik.values.nature_of_business = "Profession";
    }
  };

  const membershipCategory = [
    "Small Scale Manufacturing Activity",
    "Large Scale Manufacturing Activity",
    "Small Scale Trading Activity",
    "Large Scale Trading Activity",
    "Small Scale Service Activity",
    "Large Scale Service Activity",
    "District Chambers Of Commerce",
    "Association",
    "Profession",
  ];
  const nature_of_business = [
    "Manufacture",
    "Trade",
    "Service",
    "Profession",
    "District Chambers Of Commerce",
    "Association",
  ];

  return (
    <div className="membership-page">
      <Toast ref={toast}></Toast>

      <div className="membership-header">
        <div className="membership-kicker">FKCCI MEMBER MANAGEMENT</div>
        <h1 className="membership-title">New Membership</h1>
        <p className="membership-subtitle">
          Fill in the details below to register a new member.
        </p>
      </div>

      <div className="membership-stepper">
        <div className={`membership-step ${activeStep === 1 ? "active" : ""}`}>
          <div className="membership-step-circle">1</div>
          <span>Basic Info</span>
        </div>
        <div className="membership-step-line"></div>
        <div className={`membership-step ${activeStep === 2 ? "active" : ""}`}>
          <div className="membership-step-circle">2</div>
          <span>Representatives</span>
        </div>
        <div className="membership-step-line"></div>
        <div className={`membership-step ${activeStep === 3 ? "active" : ""}`}>
          <div className="membership-step-circle">3</div>
          <span>Compliance</span>
        </div>
        <div className="membership-step-line"></div>
        <div className={`membership-step ${activeStep === 4 ? "active" : ""}`}>
          <div className="membership-step-circle">4</div>
          <span>Payment</span>
        </div>
      </div>

      <form onSubmit={formik.handleSubmit} className="membership-form">
        <div
          className="membership-card"
          onFocusCapture={() => setActiveStep(1)}
        >
          <div className="membership-card-header">
            <div>
              <h2>Organisation Details</h2>
              <p>Core membership and organisation information</p>
            </div>
          </div>

          <div className="membership-grid membership-grid-3">
            <div className="membership-field">
              <label className={formik.errors.MEM_id_no ? "error" : ""}>
                Membership ID *
              </label>
              <InputText
                id="MEM_id_no"
                value={formik.values.MEM_id_no}
                onChange={formik.handleChange}
                placeholder="e.g. FKCCI/2024/001"
                className="membership-input"
              />
            </div>

            <div className="membership-field">
              <label className={formik.errors.member_category ? "error" : ""}>
                Member Category *
              </label>
              <Dropdown
                id="member_category"
                value={formik.values.member_category}
                onChange={formik.handleChange}
                options={memberOptions}
                placeholder="Select category"
                className="membership-input"
              />
            </div>

            <div className="membership-field">
              <label
                className={formik.errors.membership_category ? "error" : ""}
              >
                Membership Category *
              </label>
              <Dropdown
                id="membership_category"
                value={formik.values.membership_category}
                onChange={(e) => {
                  formik.handleChange(e);
                  setNatureOfBussiness(e.target.value);
                }}
                options={membershipCategory}
                placeholder="Select type"
                className="membership-input"
              />
            </div>
          </div>

          <div className="membership-grid membership-grid-3">
            <div className="membership-field">
              <label className={formik.errors.name_of_org ? "error" : ""}>
                Name of Organisation *
              </label>
              <InputText
                id="name_of_org"
                value={formik.values.name_of_org}
                onChange={formik.handleChange}
                placeholder="Organisation name"
                className="membership-input"
              />
            </div>

            <div className="membership-field">
              <label>Nature of Business</label>
              <Dropdown
                id="nature_of_business"
                value={formik.values.nature_of_business}
                onChange={formik.handleChange}
                options={nature_of_business}
                placeholder="Select business"
                className="membership-input"
              />
            </div>

            <div className="membership-field">
              <label>Status</label>
              <Dropdown
                id="is_active"
                options={[
                  { name: "Active", code: "true" },
                  { name: "Deactive", code: "false" },
                ]}
                optionLabel="name"
                optionValue="code"
                value={formik.values.is_active}
                onChange={formik.handleChange}
                placeholder="Select status"
                className="membership-input"
              />
            </div>
          </div>

          <div className="membership-grid membership-grid-3">
            <div className="membership-field">
              <label>Admission Date</label>
              <Calendar
                id="date_of_admission"
                value={formik.values.date_of_admission}
                onChange={formik.handleChange}
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
                className="membership-input"
              />
            </div>

            <div className="membership-field">
              <label>Establishment Date</label>
              <Calendar
                id="date_of_estd"
                value={formik.values.date_of_estd}
                onChange={formik.handleChange}
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
                className="membership-input"
              />
            </div>

            <div className="membership-field">
              <label>Email</label>
              <InputText
                id="email"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.email}
                placeholder="office@company.com"
                disabled={location.state?.isUpdate}
                className="membership-input"
              />
            </div>
          </div>
        </div>

        <div
          className="membership-card"
          onFocusCapture={() => setActiveStep(1)}
        >
          <div className="membership-card-header">
            <div>
              <h2>Contact & Address</h2>
              <p>Registered office address and contact details</p>
            </div>
          </div>

          <div className="membership-grid membership-grid-3">
            <div className="membership-field membership-col-span-3">
              <label className={formik.errors.address ? "error" : ""}>
                Address *
              </label>
              <InputText
                id="address"
                value={formik.values.address}
                onChange={formik.handleChange}
                placeholder="Street address"
                className="membership-input"
              />
            </div>

            <div className="membership-field">
              <label>City</label>
              <InputText
                id="city"
                value={formik.values.city}
                onChange={formik.handleChange}
                placeholder="City"
                className="membership-input"
              />
            </div>

            <div className="membership-field">
              <label>Pincode</label>
              <InputText
                id="pincode"
                value={formik.values.pincode}
                onChange={formik.handleChange}
                placeholder="560001"
                className="membership-input"
              />
            </div>

            <div className="membership-field">
              <label className={formik.errors.state ? "error" : ""}>
                State *
              </label>
              <InputText
                id="state"
                value={formik.values.state}
                onChange={formik.handleChange}
                placeholder="State"
                className="membership-input"
              />
            </div>

            <div className="membership-field">
              <label>Phone Number</label>
              <InputText
                id="phone_number"
                value={formik.values.phone_number}
                onChange={formik.handleChange}
                placeholder="+91 80 XXXX XXXX"
                className="membership-input"
              />
            </div>

            <div className="membership-field">
              <label>Fax</label>
              <InputText
                id="fax"
                value={formik.values.fax}
                onChange={formik.handleChange}
                placeholder="Fax number"
                className="membership-input"
              />
            </div>

            <div className="membership-field membership-col-span-3">
              <label>Website</label>
              <InputText
                id="website"
                value={formik.values.website}
                onChange={formik.handleChange}
                placeholder="https://example.com"
                className="membership-input"
              />
            </div>
          </div>
        </div>

        <div
          className="membership-card"
          onFocusCapture={() => setActiveStep(2)}
        >
          <div className="membership-card-header">
            <div>
              <h2>Representatives</h2>
              <p>Up to 3 authorised representatives for this membership</p>
            </div>
          </div>

          <div className="membership-grid membership-grid-3">
            {[1, 2, 3].map((repNum) => (
              <div className="membership-rep-card" key={repNum}>
                <div className="membership-rep-header">
                  <span className="membership-rep-badge">{repNum}</span>
                  <h3>Representative {repNum}</h3>
                  {repNum === 1 ? (
                    <span className="membership-required">REQUIRED</span>
                  ) : null}
                </div>

                <div className="membership-rep-body">
                  <div className="membership-grid membership-grid-3">
                    <div className="membership-field">
                      <label
                        className={
                          repNum === 1 && formik.errors.representative1_first_name
                            ? "error"
                            : ""
                        }
                      >
                        First Name {repNum === 1 ? "*" : ""}
                      </label>
                      <InputText
                        id={`representative${repNum}_first_name`}
                        value={formik.values[`representative${repNum}_first_name`]}
                        onChange={formik.handleChange}
                        placeholder="First name"
                        className="membership-input"
                      />
                    </div>

                    <div className="membership-field">
                      <label>Middle Name</label>
                      <InputText
                        id={`representative${repNum}_middle_name`}
                        value={formik.values[`representative${repNum}_middle_name`]}
                        onChange={formik.handleChange}
                        placeholder="Middle name"
                        className="membership-input"
                      />
                    </div>

                    <div className="membership-field">
                      <label
                        className={
                          repNum === 1 && formik.errors.representative1_last_name
                            ? "error"
                            : ""
                        }
                      >
                        Last Name {repNum === 1 ? "*" : ""}
                      </label>
                      <InputText
                        id={`representative${repNum}_last_name`}
                        value={formik.values[`representative${repNum}_last_name`]}
                        onChange={formik.handleChange}
                        placeholder="Last name"
                        className="membership-input"
                      />
                    </div>
                  </div>

                  <div className="membership-field">
                    <label
                      className={
                        repNum === 1 &&
                        formik.errors.designation_of_representative1
                          ? "error"
                          : ""
                      }
                    >
                      Designation {repNum === 1 ? "*" : ""}
                    </label>
                    <InputText
                      id={`designation_of_representative${repNum}`}
                      value={
                        formik.values[`designation_of_representative${repNum}`]
                      }
                      onChange={formik.handleChange}
                      placeholder="e.g. Director"
                      className="membership-input"
                    />
                  </div>

                  <div className="membership-field">
                    <label>Email</label>
                    <InputText
                      id={`email_of_representative${repNum}`}
                      value={
                        formik.values[`email_of_representative${repNum}`]
                      }
                      onChange={formik.handleChange}
                      placeholder="representative@email.com"
                      className="membership-input"
                    />
                  </div>

                  <div className="membership-field">
                    <label>Mobile Number</label>
                    <InputText
                      id={repNum === 1 ? "mobile" : `mobile_of_repr${repNum}`}
                      value={
                        repNum === 1
                          ? formik.values.mobile
                          : formik.values[`mobile_of_repr${repNum}`]
                      }
                      onChange={(e) =>
                        handleMobileChange(
                          e,
                          repNum === 1 ? "mobile" : `mobile_of_repr${repNum}`
                        )
                      }
                      inputMode="numeric"
                      // pattern="\\d*"
                      maxLength={10}
                      placeholder="+91 00000 00000"
                      className="membership-input"
                    />
                  </div>

                  <div className="membership-field">
                    <label>Photo</label>
                    <div className="membership-upload">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          if (repNum === 1) setImg1(e.target.files[0]);
                          if (repNum === 2) setImg2(e.target.files[0]);
                          if (repNum === 3) setImg3(e.target.files[0]);
                        }}
                      />
                      <div className="membership-upload-hint">
                        Choose image - JPG, PNG
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div
          className="membership-card"
          onFocusCapture={() => setActiveStep(3)}
        >
          <div className="membership-card-header">
            <div>
              <h2>Compliance & Financials</h2>
              <p>Regulatory numbers, turnover, and referral details</p>
            </div>
          </div>

          <div className="membership-grid membership-grid-4">
            <div className="membership-field">
              <label>GSTIN</label>
              <InputText
                id="GSTIN"
                value={formik.values.GSTIN}
                onChange={formik.handleChange}
                placeholder="22AAAAA0000AIZ5"
                className="membership-input"
              />
            </div>
            <div className="membership-field">
              <label>PAN</label>
              <InputText
                id="PAN"
                value={formik.values.PAN}
                onChange={formik.handleChange}
                placeholder="AAAPL1234C"
                className="membership-input"
              />
            </div>
            <div className="membership-field">
              <label>CIN</label>
              <InputText
                id="cin_no"
                value={formik.values.cin_no}
                onChange={formik.handleChange}
                placeholder="CIN number"
                className="membership-input"
              />
            </div>
            <div className="membership-field">
              <label>MSME Registration No.</label>
              <InputText
                id="MSME_registration_no"
                value={formik.values.MSME_registration_no}
                onChange={formik.handleChange}
                placeholder="MSME number"
                className="membership-input"
              />
            </div>
          </div>

          <div className="membership-grid membership-grid-4">
            <div className="membership-field">
              <label>Annual Turnover</label>
              <InputText
                id="annual_turnover"
                value={formik.values.annual_turnover}
                onChange={formik.handleChange}
                placeholder="e.g. 50,00,000"
                className="membership-input"
              />
            </div>
            <div className="membership-field">
              <label>Exports</label>
              <InputText
                id="exports"
                value={formik.values.exports}
                onChange={formik.handleChange}
                placeholder="Export details"
                className="membership-input"
              />
            </div>
            <div className="membership-field">
              <label>Proposed By</label>
              <InputText
                id="proposed_by"
                value={formik.values.proposed_by}
                onChange={formik.handleChange}
                placeholder="Name"
                className="membership-input"
              />
            </div>
            <div className="membership-field">
              <label>Seconded By</label>
              <InputText
                id="seconded_by"
                value={formik.values.seconded_by}
                onChange={formik.handleChange}
                placeholder="Name"
                className="membership-input"
              />
            </div>
          </div>

          <div className="membership-grid membership-grid-4">
            <div className="membership-field">
              <label>Introducer Name</label>
              <InputText
                id="introducer_name"
                value={formik.values.introducer_name}
                onChange={formik.handleChange}
                placeholder="Name"
                className="membership-input"
              />
            </div>
            <div className="membership-field">
              <label>Introducer Mobile</label>
              <InputText
                id="introducer_mobile_no"
                value={formik.values.introducer_mobile_no}
                onChange={(e) => handleMobileChange(e, "introducer_mobile_no")}
                inputMode="numeric"
                // pattern="\\d*"
                maxLength={10}
                placeholder="+91 XXXXX XXXXX"
                className="membership-input"
              />
            </div>
            <div className="membership-field">
              <label>Referred By</label>
              <InputText
                id="referred_by"
                value={formik.values.referred_by}
                onChange={formik.handleChange}
                placeholder="Name"
                className="membership-input"
              />
            </div>
            <div className="membership-field">
              <label>Remarks</label>
              <InputText
                id="remarks"
                value={formik.values.remarks}
                onChange={formik.handleChange}
                placeholder="Any additional notes"
                className="membership-input"
              />
            </div>
          </div>

          <div className="membership-field">
            <label>Product / Service Description</label>
            <InputTextarea
              id="product_desc"
              value={formik.values.product_desc}
              onChange={formik.handleChange}
              placeholder="Describe the organisation's products or services..."
              rows={4}
              className="membership-input"
            ></InputTextarea>
          </div>
        </div>

        <div
          className="membership-card"
          onFocusCapture={() => setActiveStep(4)}
        >
          <div className="membership-card-header">
            <div>
              <h2>Payment Details</h2>
              <p>Subscription payment information</p>
            </div>
          </div>

          <div className="membership-grid membership-grid-4">
            <div className="membership-field">
              <label>Payment Method</label>
              <Dropdown
                id="payment_type"
                options={["cheque", "NEFT"]}
                value={formik.values.payment_type}
                onChange={formik.handleChange}
                placeholder="Select method"
                className="membership-input"
              />
            </div>
            <div className="membership-field">
              <label>Payment Reference / Details</label>
              <InputText
                id="payment_type_no"
                value={formik.values.payment_type_no}
                onChange={formik.handleChange}
                placeholder="Cheque no. / UTR"
                className="membership-input"
              />
            </div>
            <div className="membership-field">
              <label>Amount Collected</label>
              <InputText
                id="amount_collected"
                value={formik.values.amount_collected}
                onChange={formik.handleChange}
                placeholder="0.00"
                className="membership-input"
              />
            </div>
            <div className="membership-field">
              <label>Membership Terminated</label>
              <Dropdown
                id="membership_terminated"
                options={[
                  { name: "Yes", code: "true" },
                  { name: "No", code: "false" },
                ]}
                value={formik.values.membership_terminated}
                onChange={formik.handleChange}
                optionLabel="name"
                optionValue="code"
                placeholder="Select"
                className="membership-input"
              />
            </div>
          </div>
        </div>

        <div className="membership-footer">
          <div className="membership-footer-note">
            Fields marked with <span>*</span> are required.
          </div>
          <div className="membership-footer-actions">
            <Button
              type="button"
              label="Cancel"
              className="p-button-outlined p-button-secondary"
              onClick={() => navigate(-1)}
            />
            {location.state?.isUpdate ? (
              <Button type="submit" label="Update" />
            ) : (
              <Button type="submit" label="Submit Membership" />
            )}
          </div>
        </div>
      </form>
    </div>
  );
};
